import React from "react";
import { observer } from "mobx-react";
import HeartFilled from "assets/icons/heart-filled.svg";
import { useStore } from "store";

import { cn } from "helpers/style";
import styles from "./AddToFavorites.module.scss";

type Props = {
  product: Entity.Product | Entity.Product.Short;
  white?: boolean;
  transparentWhite?: boolean;
};

const AddToFavorites: React.FC<Props> = ({
  product,
  white,
  transparentWhite,
}: Props) => {
  const { favorites, user } = useStore();
  const inFavorites = user.isAuth && favorites.has(product.id);

  function addToFavorites(event) {
    event && event.preventDefault();

    if (inFavorites) {
      favorites.remove(product.id);
    } else {
      favorites.add(product.id);
    }
  }

  if (!user.isAuth) return null;

  return (
    <div
      className={cn([
        styles.addToFavorites,
        inFavorites && styles.addToFavoritesAccent,
        white && styles.addToFavoritesWhite,
        transparentWhite && styles.addToFavoritesTransparentWhite,
      ])}
      onClick={addToFavorites}
    >
      <HeartFilled />
    </div>
  );
};

export default observer(AddToFavorites);
